"use client";

import { CasesV2 } from "./CasesV2";

export const CasesCmsSwitch = () => {
  return <CasesV2 />;
};
